// src/components/Layout.jsx
import { useState } from "react";
import { Container, Row, Col, Button, Stack } from "react-bootstrap";
import SidebarContent from "./SidebarContent";
import { Outlet } from "react-router-dom";
import logo from "../../assets/logo_fcfm.png";

const styles = {
  container: {
    minHeight: "100dvh",
  },
  sidebar: {
    background: "var(--color-background-3)",
    minHeight: "100dvh",
    maxHeight: "100dvh",
    overflowY: "auto",
  },
  sidebarMobile: {
    background: "var(--color-background-3)",
    zIndex: 1030,
    boxShadow: "2px 0 8px rgba(0,0,0,0.1)",
  },
  topBar: {
    background: "var(--color-background-3)",
    zIndex: 1030,
    minWidth: "100dvw",
  },

  openButton: {
    background: "none",
    border: "none",
    color: "var(--color-text)",
  },
};

function Layout() {
  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () => setShowSidebar(!showSidebar);

  return (
    <div className="w-100 overflow-x-hidden m-0 p-0" style={styles.container}>
      {/* Header solo visible en pantallas pequeñas */}
      <Row
        className="d-md-none border-bottom py-2 px-3 align-items-center position-fixed top-0 start-0 m-0 w-100"
        style={styles.topBar}
      >
        <Col xs="auto">
          <Button
            variant="light"
            className="fs-3"
            onClick={toggleSidebar}
            style={styles.openButton}
          >
            ☰
          </Button>
        </Col>
        <Col xs={{ order: "last" }} className="text-end">
          <img
            src={logo}
            alt="logo"
            className="img-fluid my-auto"
            style={{ maxHeight: "30px", width: "auto" }}
          />{" "}
        </Col>
      </Row>

      <Row className="h-100 px-3">
        {/* Sidebar visible solo en pantallas medianas o más grandes */}
        <Col
          md={3}
          lg={2}
          className="border-end p-0 d-none d-md-block"
          style={styles.sidebar}
        >
          <SidebarContent />
        </Col>

        {/* Sidebar móvil que aparece sobre el contenido cuando showSidebar = true */}
        {showSidebar && (
          <Col
            xs={12}
            className="border-bottom d-md-none px-3 position-fixed start-0"
            style={styles.sidebarMobile}
          >
            <SidebarContent onNavigate={toggleSidebar} mobile={true} />
          </Col>
        )}

        {/* Contenido principal */}
        <Col
          xs={12}
          md={9}
          lg={10}
          className="px-xs-1 px-md-4 pt-5 my-4 my-md-0 py-md-4"
          style={{ overflowY: "auto", maxHeight: "100dvh" }}
        >
          <Outlet />
        </Col>
      </Row>
    </div>
  );
}

export default Layout;
